module.exports = __webpack_public_path__ + "static/media/noAttendanceIcon.25cef9a6.svg";